export default {

    me () {
        return {
            method: 'GET',
            url: '/me'
        }
    },

    home (params) {
        return {
            method: 'GET',
            url: '/home',
            params
        }
    },

    buildings (params) {
        return {
            method: 'GET',
            url: '/buildings',
            params
        }
    },

    deals (params) {
        return {
            method: 'GET',
            url: '/deals',
            params
        }
    },

    heatmap (params) {
        return {
            method: 'GET',
            url: '/heatmap',
            params
        }
    },

    charts (params) {
        return {
            method: 'GET',
            url: '/charts',
            params
        }
    },

    upload (file, type) {
        return {
            method: 'POST',
            url: '/upload/',
            data: file,
            headers: {
                'Content-Type': type
            }
        }
    },

    parse (key) {
        return {
            method: 'GET',
            url: '/parse/' + key
        }
    },

    preimport (key, data) {
        return {
            method: 'POST',
            url: '/preimport/' + key,
            data
        }
    },

    import (key) {
        return {
            method: 'POST',
            url: '/import/' + key
        }
    },

    convert (key, data, params) {
        return {
            method: 'POST',
            url: '/convert/' + key,
            data,
            params
        }
    },

    export () {
        return {
            method: 'POST',
            url: '/export/'
        }
    },

    get (id) {
        return {
            method: 'GET',
            url: '/deals/' + id
        }
    },

    create (data) {
        return {
            method: 'POST',
            url: '/deals',
            data
        }
    },

    update (id, data) {
        return {
            method: 'PUT',
            url: '/deals/' + id,
            data
        }
    },

    delete (id, all = false) {
        const ids = Array.isArray(id) ? id : [id];
        return {
            method: 'DELETE',
            url: '/deals',
            params: {all},
            data: {ids}
        }
    },

    report (params) {
        return {
            method: 'GET',
            url: '/report',
            responseType: 'blob',
            params,
        }
    },

    refresh (token) {
        return {
            method: 'GET',
            url: '/refresh',
            headers: {
                'Authorization': 'Bearer ' + token
            },
            refreshed: true
        }
    }

}
